var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgObjectNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 6a1 1 0 0 1-1 1 3 3 0 0 0-3 3 1 1 0 0 1-2 0 5.006 5.006 0 0 1 5-5 1 1 0 0 1 1 1m8 4a8.96 8.96 0 0 1-5 8.06V19a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-.94A9 9 0 1 1 21 10m-2 0a7 7 0 1 0-9.625 6.486 1 1 0 0 1 .625.927V18h4v-.587a1 1 0 0 1 .625-.927A6.97 6.97 0 0 0 19 10m-4 13a1 1 0 0 0 0-2H9a1 1 0 1 0 0 2z"
})));
export default SvgObjectNew;